export const getScreenSize = (width) => {
    if (width >= 1536) return '2xl';
    if (width >= 1300) return 'xl';
    if (width >= 1024) return 'lg';
    if (width >= 768) return 'md';
    if (width >= 640) return 'sm';
    return 'xs';  
  };
  